var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBridge = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  width: 3333.333,
  height: 640,
  viewBox: "0 0 3333 640",
  ref: ref
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "bridge_svg__a",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 480h2500V0H0Z"
})))), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#bridge_svg__a)",
  transform: "matrix(1.33333 0 0 -1.33333 0 640)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-138.761a25.2 25.2 0 0 1-15.742-5.522l-14.194-11.356a25.207 25.207 0 0 0-15.742-5.522h-225.332a25.195 25.195 0 0 1-13.977-4.233L-467.8-56H0Z",
  style: {
    fill: "var(--illustration-secondary)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(2506 192)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-138.761a25.2 25.2 0 0 1-15.742-5.522l-14.194-11.356a25.207 25.207 0 0 0-15.742-5.522h-225.332a25.195 25.195 0 0 1-13.977-4.233L-467.8-56H0Z",
  style: {
    fill: "none",
    stroke: "var(--illustration-secondary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(2506 192)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0a36.004 36.004 0 0 1-17.239 4.396h-136.82v-56H-5.407a36 36 0 0 0 20.645-6.508l13.56-9.492h91.143z",
  style: {
    fill: "var(--illustration-secondary)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(130.06 259.604)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0a36.004 36.004 0 0 1-17.239 4.396h-136.82v-56H-5.407a36 36 0 0 0 20.645-6.508l13.56-9.492h91.143z",
  style: {
    fill: "none",
    stroke: "var(--illustration-secondary)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(130.06 259.604)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-36.951a36.001 36.001 0 0 0-20.163 6.176l-52.729 35.648A36.001 36.001 0 0 1-130.006 48h-351.039c-4.58 0-9.118.874-13.371 2.575l-27.126 10.85A35.997 35.997 0 0 1-534.912 64h-71.095a36 36 0 0 0-18.522 5.13l-62.899 37.74A36 36 0 0 1-705.95 112h-440.314l24.989-17.492A35.99 35.99 0 0 1-1100.63 88h359.125a36 36 0 0 0 23.706-8.907l43.641-38.186A36 36 0 0 1-650.452 32h36.659a36.002 36.002 0 0 0 24.083-9.241l59.463-53.518A36.002 36.002 0 0 1-506.164-40h242.185v64h100.464a35.999 35.999 0 0 0 20.924-6.706l37.225-26.589A36.005 36.005 0 0 1-84.442-16h77.187A135.284 135.284 0 0 0 0 0",
  style: {
    fill: "var(--illustration-secondary)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(1327.978 64)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-36.951a36.001 36.001 0 0 0-20.163 6.176l-52.729 35.648A36.001 36.001 0 0 1-130.006 48h-351.039c-4.58 0-9.118.874-13.371 2.575l-27.126 10.85A35.997 35.997 0 0 1-534.912 64h-71.095a36 36 0 0 0-18.522 5.13l-62.899 37.74A36 36 0 0 1-705.95 112h-440.314l24.989-17.492A35.99 35.99 0 0 1-1100.63 88h359.125a36 36 0 0 0 23.706-8.907l43.641-38.186A36 36 0 0 1-650.452 32h36.659a36.002 36.002 0 0 0 24.083-9.241l59.463-53.518A36.002 36.002 0 0 1-506.164-40h242.185v64h100.464a35.999 35.999 0 0 0 20.924-6.706l37.225-26.589A36.005 36.005 0 0 1-84.442-16h77.187A135.284 135.284 0 0 0 0 0z",
  style: {
    fill: "none",
    stroke: "var(--illustration-secondary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1327.978 64)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h7.995",
  style: {
    fill: "none",
    stroke: "var(--illustration-secondary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1152.005 300)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h31.872",
  style: {
    fill: "none",
    stroke: "var(--illustration-secondary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1112 300)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 25.09 6.723",
  style: {
    fill: "none",
    stroke: "var(--illustration-secondary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1110.91 308.282)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 25.09-6.723",
  style: {
    fill: "none",
    stroke: "var(--illustration-secondary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1110.91 291.718)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-7.995",
  style: {
    fill: "none",
    stroke: "var(--illustration-secondary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(984.995 300)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-31.872",
  style: {
    fill: "none",
    stroke: "var(--illustration-secondary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1025 300)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0-25.09 6.723",
  style: {
    fill: "none",
    stroke: "var(--illustration-secondary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1026.09 308.282)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0-25.09-6.723",
  style: {
    fill: "none",
    stroke: "var(--illustration-secondary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1026.09 291.718)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h8v8Z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(824 48)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0a36 36 0 0 1-25.456 10.544h-93.551a36.004 36.004 0 0 0-20.925 6.706l-37.224 26.588a36.004 36.004 0 0 1-20.925 6.706h-44.463v-88h280z",
  style: {
    fill: "var(--illustration-background)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(1362.544 37.456)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0a36 36 0 0 1-25.456 10.544h-93.551a36.004 36.004 0 0 0-20.925 6.706l-37.224 26.588a36.004 36.004 0 0 1-20.925 6.706h-44.463v-88h280z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1362.544 37.456)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0c0-11.046-6-20-6-20v40s6-8.954 6-20",
  style: {
    fill: "var(--illustration-secondary)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(1076 300)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0c0-11.046-6-20-6-20v40s6-8.954 6-20Z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1076 300)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0c0-11.046 6-20 6-20v40S0 11.046 0 0",
  style: {
    fill: "var(--illustration-secondary)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(1052 300)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0c0-11.046 6-20 6-20v40S0 11.046 0 0Z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1052 300)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0-12.024-104h-12z",
  style: {
    fill: "var(--illustration-secondary)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(568.024 104)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0-12.024-104h-12z",
  style: {
    fill: "none",
    stroke: "var(--illustration-secondary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(568.024 104)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0c0 3.727 2.551 6.849 6 7.738A7.992 7.992 0 0 1 4 8 8 8 0 0 1 4-8c.692 0 1.36.097 2 .262C2.551-6.849 0-3.727 0 0",
  style: {
    fill: "var(--illustration-secondary)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(900 152)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0c0 3.727 2.551 6.849 6 7.738A7.992 7.992 0 0 1 4 8 8 8 0 0 1 4-8c.692 0 1.36.097 2 .262C2.551-6.849 0-3.727 0 0Z",
  style: {
    fill: "none",
    stroke: "var(--illustration-secondary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(900 152)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0c0 5.944 4.327 10.866 10 11.82-.652.11-1.317.18-2 .18C1.373 12-4 6.627-4 0S1.373-12 8-12c.683 0 1.348.07 2 .18C4.327-10.866 0-5.944 0 0",
  style: {
    fill: "var(--illustration-secondary)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(936 156)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0c0 5.944 4.327 10.866 10 11.82-.652.11-1.317.18-2 .18C1.373 12-4 6.627-4 0S1.373-12 8-12c.683 0 1.348.07 2 .18C4.327-10.866 0-5.944 0 0Z",
  style: {
    fill: "none",
    stroke: "var(--illustration-secondary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(936 156)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h32l48 80Z",
  style: {
    fill: "var(--illustration-secondary)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(496 224)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h32l48 80Z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(496 224)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0-48-80H80Z",
  style: {
    fill: "var(--illustration-background)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(576 304)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0-48-80H80Z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(576 304)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24l32 56Z",
  style: {
    fill: "var(--illustration-secondary)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(672 240)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24l32 56Z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(672 240)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0-80-80H80Z",
  style: {
    fill: "var(--illustration-background)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(448 304)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0-80-80H80Z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(448 304)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-150.029a35.996 35.996 0 0 0-18.521 5.13l-22.9 13.74A35.996 35.996 0 0 1-209.971 24h-84.468a36.005 36.005 0 0 0-17.862 4.743l-39.398 22.514A36.005 36.005 0 0 1-369.561 56H-848",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1008 136)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 .359-16h-71.641c-8.837 0-16-7.163-16-16v-24h-8.359V-.253z",
  style: {
    fill: "var(--illustration-secondary)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(1007.641 56)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 .359-16h-71.641c-8.837 0-16-7.163-16-16v-24h-8.359V-.253z",
  style: {
    fill: "none",
    stroke: "var(--illustration-secondary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1007.641 56)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 39.997 40L80.059 0v-56H0Z",
  style: {
    fill: "var(--illustration-background)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(832 56)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 39.997 40L80.059 0v-56H0Z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(832 56)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-135.941l48.032-47.971H48.033Z",
  style: {
    fill: "var(--illustration-background)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(1007.938 96)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-135.941l48.032-47.971H48.033Z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1007.938 96)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 48.062-48",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(879.938 96)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 48.062-48",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(887.938 96)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 48.062-48",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(896 96)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 48.063-48",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(904.062 96)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 48.062-48",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(912.125 96)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 48.063-48",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(920.187 96)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 48.062-48",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(928.249 96)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 48.062-48",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(936.311 96)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 48.063-48",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(944.373 96)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 48.062-48",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(952.436 96)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 48.062-48",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(960.498 96)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 48.063-48",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(968.56 96)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 48.062-48",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(976.622 96)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 48.063-48",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(984.684 96)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 48.063-48",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(992.746 96)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 48.062-48",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1000.809 96)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 47.997 48L96.029.029",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(824 48)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-10.186a36 36 0 0 0-24.082 9.241l-59.464 53.518A36 36 0 0 1-117.814 72h-36.66a36.003 36.003 0 0 0-23.706 8.907l-43.64 38.186A36.003 36.003 0 0 1-245.526 128h-359.126a35.992 35.992 0 0 0-20.645 6.508l-61.406 42.984A35.992 35.992 0 0 1-707.348 184H-852",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(832 24)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0a3 3 0 1 0-6 0 3 3 0 0 0 6 0",
  style: {
    fill: "var(--illustration-background)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(835 24)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0a3 3 0 1 0-6 0 3 3 0 0 0 6 0z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(835 24)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 23.976-104h-48z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(568.024 104)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v64",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(568)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 8 8",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(568 8)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0-8 8",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(568 16)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 8 8",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(568 24)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0-8 8",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(568 32)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0-4 4",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(568 48)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0c0 13.403 9.42 24.602 22 27.349A28.103 28.103 0 0 1 16 28C.536 28-12 15.464-12 0S.536-28 16-28c2.061 0 4.066.229 6 .651C9.42-24.602 0-13.403 0 0",
  style: {
    fill: "var(--illustration-secondary)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(664 44)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0c0 13.403 9.42 24.602 22 27.349A28.103 28.103 0 0 1 16 28C.536 28-12 15.464-12 0S.536-28 16-28c2.061 0 4.066.229 6 .651C9.42-24.602 0-13.403 0 0Z",
  style: {
    fill: "none",
    stroke: "var(--illustration-secondary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(664 44)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0c0-15.464-12.536-28-28-28S-56-15.464-56 0s12.536 28 28 28S0 15.464 0 0Z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(708 44)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-56",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(680 56)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 16 16",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(680 32)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0c0 13.403 9.42 24.602 22 27.349A28.103 28.103 0 0 1 16 28C.536 28-12 15.464-12 0S.536-28 16-28c2.061 0 4.066.229 6 .651C9.42-24.602 0-13.403 0 0",
  style: {
    fill: "var(--illustration-secondary)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(204 44)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0c0 13.403 9.42 24.602 22 27.349A28.103 28.103 0 0 1 16 28C.536 28-12 15.464-12 0S.536-28 16-28c2.061 0 4.066.229 6 .651C9.42-24.602 0-13.403 0 0Z",
  style: {
    fill: "none",
    stroke: "var(--illustration-secondary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(204 44)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0c0-15.464-12.536-28-28-28S-56-15.464-56 0s12.536 28 28 28S0 15.464 0 0Z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(248 44)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-56",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(220 56)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 16 16",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(220 32)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0-32-56-40 40-32-56H72Z",
  style: {
    fill: "var(--illustration-background)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(728 296)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0-32-56-40 40-32-56H72Z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(728 296)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24l32 56Z",
  style: {
    fill: "var(--illustration-secondary)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(600 224)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24l32 56Z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(600 224)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24l80 80z",
  style: {
    fill: "var(--illustration-secondary)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(344 224)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24l80 80z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(344 224)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24l24 48Z",
  style: {
    fill: "var(--illustration-secondary)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(128 280)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24l24 48Z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(128 280)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0-24-48h72Z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(176 328)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0-80-80H80Z",
  style: {
    fill: "var(--illustration-background)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(64 360)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0-80-80H80Z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(64 360)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-8l4 16z",
  style: {
    fill: "var(--illustration-background)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(584 228)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-8l4 16z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(584 228)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-4",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(580 228)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-8l4 16z",
  style: {
    fill: "var(--illustration-background)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(656 228)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-8l4 16z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(656 228)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-4",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(652 228)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-8l4 16z",
  style: {
    fill: "var(--illustration-background)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(744 228)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-8l4 16z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(744 228)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-4",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(740 228)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-4l8 32Z",
  style: {
    fill: "var(--illustration-secondary)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(716 168)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-4l8 32Z",
  style: {
    fill: "none",
    stroke: "var(--illustration-secondary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(716 168)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-16l8 32z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(728 168)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-16",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(720 176)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-4l8 24Z",
  style: {
    fill: "var(--illustration-secondary)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(508 160)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-4l8 24Z",
  style: {
    fill: "none",
    stroke: "var(--illustration-secondary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(508 160)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-16l8 24z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(520 160)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-16",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(512 168)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-8l4 16z",
  style: {
    fill: "var(--illustration-background)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(760 228)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-8l4 16z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(760 228)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-4",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(756 228)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-8l4 16z",
  style: {
    fill: "var(--illustration-background)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(456 228)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-8l4 16z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(456 228)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-4",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(452 228)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-8l4 16z",
  style: {
    fill: "var(--illustration-background)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(472 228)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-8l4 16z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(472 228)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-4",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(468 228)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-8l4 16z",
  style: {
    fill: "var(--illustration-background)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(192 284)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-8l4 16z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(192 284)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-4",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(188 284)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-8l4 16z",
  style: {
    fill: "var(--illustration-background)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(776 228)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-8l4 16z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(776 228)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-4",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(772 228)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-4",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(828 228)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0a6 6 0 1 0-12 0A6 6 0 0 0 0 0",
  style: {
    fill: "var(--illustration-background)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(834 234)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0a6 6 0 1 0-12 0A6 6 0 0 0 0 0z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(834 234)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-4",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(390 196)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0a6 6 0 1 0-12 0A6 6 0 0 0 0 0",
  style: {
    fill: "var(--illustration-background)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(396 202)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0a6 6 0 1 0-12 0A6 6 0 0 0 0 0z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(396 202)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-4",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(262 196)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0a6 6 0 1 0-12 0A6 6 0 0 0 0 0",
  style: {
    fill: "var(--illustration-background)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(268 202)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0a6 6 0 1 0-12 0A6 6 0 0 0 0 0z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(268 202)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-4",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(234 196)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0a6 6 0 1 0-12.002.002A6 6 0 0 0 0 0",
  style: {
    fill: "var(--illustration-background)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(240 202)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0a6 6 0 1 0-12.002.002A6 6 0 0 0 0 0z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(240 202)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-4",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(206 196)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0a6 6 0 1 0-12.002.002A6 6 0 0 0 0 0",
  style: {
    fill: "var(--illustration-background)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(212 202)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0a6 6 0 1 0-12.002.002A6 6 0 0 0 0 0z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(212 202)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-4",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(914 204)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0a6 6 0 1 0-12 0A6 6 0 0 0 0 0",
  style: {
    fill: "var(--illustration-background)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(920 210)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0a6 6 0 1 0-12 0A6 6 0 0 0 0 0z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(920 210)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-4",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(962 204)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0a6 6 0 1 0-12 0A6 6 0 0 0 0 0",
  style: {
    fill: "var(--illustration-background)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(968 210)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0a6 6 0 1 0-12 0A6 6 0 0 0 0 0z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(968 210)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-4",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1174 204)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0a6 6 0 1 0-12 0A6 6 0 0 0 0 0",
  style: {
    fill: "var(--illustration-background)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(1180 210)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0a6 6 0 1 0-12 0A6 6 0 0 0 0 0z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1180 210)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-4",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1222 204)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0a6 6 0 1 0-12 0A6 6 0 0 0 0 0",
  style: {
    fill: "var(--illustration-background)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(1228 210)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0a6 6 0 1 0-12 0A6 6 0 0 0 0 0z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1228 210)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-4",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(2078.497 188)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0a6 6 0 1 0-12 0A6 6 0 0 0 0 0",
  style: {
    fill: "var(--illustration-background)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(2084.497 194)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0a6 6 0 1 0-12 0A6 6 0 0 0 0 0z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(2084.497 194)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-4",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(2126.497 188)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0a6 6 0 1 0-12 0A6 6 0 0 0 0 0",
  style: {
    fill: "var(--illustration-background)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(2132.497 194)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0a6 6 0 1 0-12 0A6 6 0 0 0 0 0z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(2132.497 194)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0c0-6.627-5.373-12-12-12S-24-6.627-24 0s5.373 12 12 12S0 6.627 0 0Z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(956 156)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0a8 8 0 1 0-16 0A8 8 0 0 0 0 0z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(912 152)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v16",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(944 136)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0c0 5.944 4.327 10.866 10 11.82-.652.11-1.317.18-2 .18C1.373 12-4 6.627-4 0S1.373-12 8-12c.683 0 1.348.07 2 .18C4.327-10.866 0-5.944 0 0",
  style: {
    fill: "var(--illustration-secondary)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(1148 156)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0c0 5.944 4.327 10.866 10 11.82-.652.11-1.317.18-2 .18C1.373 12-4 6.627-4 0S1.373-12 8-12c.683 0 1.348.07 2 .18C4.327-10.866 0-5.944 0 0Z",
  style: {
    fill: "none",
    stroke: "var(--illustration-secondary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1148 156)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0c0-6.627-5.373-12-12-12S-24-6.627-24 0s5.373 12 12 12S0 6.627 0 0Z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1168 156)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v16",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1156 136)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v16",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(904 136)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0c0 3.727 2.552 6.849 6 7.738A7.998 7.998 0 0 1 4 8 8 8 0 0 1 4-8c.692 0 1.359.097 2 .262C2.552-6.849 0-3.727 0 0",
  style: {
    fill: "var(--illustration-secondary)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(1308 104)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0c0 3.727 2.552 6.849 6 7.738A7.998 7.998 0 0 1 4 8 8 8 0 0 1 4-8c.692 0 1.359.097 2 .262C2.552-6.849 0-3.727 0 0Z",
  style: {
    fill: "none",
    stroke: "var(--illustration-secondary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1308 104)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0a8 8 0 1 0-16 0A8 8 0 0 0 0 0z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1320 104)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v16",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1312 88)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h16l16-16H8Z",
  style: {
    fill: "var(--illustration-secondary)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(1016 272)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h16l16-16H8Z",
  style: {
    fill: "none",
    stroke: "var(--illustration-secondary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1016 272)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0c0 5.213-3.837 9.439-8.571 9.439a7.864 7.864 0 0 1-3.165-.672c-.989 4.01-4.309 6.964-8.264 6.964a7.88 7.88 0 0 1-3.165-.671c-.988 4.01-4.308 6.964-8.264 6.964-4.734 0-8.571-4.225-8.571-9.438 0-2.679 1.018-5.091 2.644-6.809h-.671v-7.753H-.193C-.07-1.338 0-.679 0 0",
  style: {
    fill: "var(--illustration-secondary)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(1168 1.976)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0c0 5.213-3.837 9.439-8.571 9.439a7.864 7.864 0 0 1-3.165-.672c-.989 4.01-4.309 6.964-8.264 6.964a7.88 7.88 0 0 1-3.165-.671c-.988 4.01-4.308 6.964-8.264 6.964-4.734 0-8.571-4.225-8.571-9.438 0-2.679 1.018-5.091 2.644-6.809h-.671v-7.753H-.193C-.07-1.338 0-.679 0 0Z",
  style: {
    fill: "none",
    stroke: "var(--illustration-secondary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1168 1.976)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-144l32 256h80z",
  style: {
    fill: "var(--illustration-background)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(1136)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-40l32 256h24Z",
  style: {
    fill: "var(--illustration-secondary)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(1032)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-40l32 256h24Z",
  style: {
    fill: "none",
    stroke: "var(--illustration-secondary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1032)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-144l32 256h80z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1136)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-10.667v10.667a5.334 5.334 0 0 0 10.667 0Z",
  style: {
    fill: "var(--illustration-primary)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(1069.333)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-10.667v10.667a5.334 5.334 0 0 0 10.667 0Z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1069.333)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-80l-1-8H1Z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1104 256)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-102l-1-8H1Z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1115 168)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-124l-1-8H1Z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1126 80)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h96l-8-16H8Z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1016 272)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v16",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1112 272)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v16",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1064 272)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v16",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1048 272)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v16",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1080 272)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v16",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1032 272)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v16",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1016 272)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1096 272h-64v56h64z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M1070 280h-12v40h12z",
  style: {
    fill: "var(--illustration-background)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h104",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1012 288)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-132a35.995 35.995 0 0 0-21.6 7.2l-12.8 9.6A35.995 35.995 0 0 1-188 24h-484l-87.593 51.096A35.996 35.996 0 0 1-777.732 80H-1040",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1016 200)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0a3 3 0 1 0-6 0 3 3 0 0 0 6 0",
  style: {
    fill: "var(--illustration-background)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(1020 200)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0a3 3 0 1 0-6 0 3 3 0 0 0 6 0z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1020 200)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-10.667v10.667a5.334 5.334 0 0 0 10.667 0Z",
  style: {
    fill: "var(--illustration-primary)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(877.363)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-10.667v10.667a5.334 5.334 0 0 0 10.667 0Z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(877.363)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0a23.888 23.888 0 0 1-13.338-4.047C-20.248 7.932-33.178 16-48 16S-75.752 7.932-82.662-4.047A23.888 23.888 0 0 1-96 0c-10.449 0-19.333-6.68-22.629-16H22.629C19.333-6.68 10.449 0 0 0",
  style: {
    fill: "var(--illustration-secondary)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(336 392)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0a23.888 23.888 0 0 1-13.338-4.047C-20.248 7.932-33.178 16-48 16S-75.752 7.932-82.662-4.047A23.888 23.888 0 0 1-96 0c-10.449 0-19.333-6.68-22.629-16H22.629C19.333-6.68 10.449 0 0 0Z",
  style: {
    fill: "none",
    stroke: "var(--illustration-secondary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(336 392)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0a23.886 23.886 0 0 1-13.338-4.047C-20.248 7.932-33.178 16-48 16S-75.752 7.932-82.662-4.047A23.888 23.888 0 0 1-96 0c-10.449 0-19.333-6.68-22.629-16H22.629C19.334-6.68 10.449 0 0 0",
  style: {
    fill: "var(--illustration-secondary)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(1305 408)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0a23.886 23.886 0 0 1-13.338-4.047C-20.248 7.932-33.178 16-48 16S-75.752 7.932-82.662-4.047A23.888 23.888 0 0 1-96 0c-10.449 0-19.333-6.68-22.629-16H22.629C19.334-6.68 10.449 0 0 0Z",
  style: {
    fill: "none",
    stroke: "var(--illustration-secondary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1305 408)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0c0 11.046-8.954 20-20 20s-20-8.954-20-20c0-1.515.183-2.984.502-4.402A19.903 19.903 0 0 1-52 0c-11.046 0-20-8.954-20-20h52C-8.954-20 0-11.046 0 0",
  style: {
    fill: "var(--illustration-secondary)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(896 332)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0c0 11.046-8.954 20-20 20s-20-8.954-20-20c0-1.515.183-2.984.502-4.402A19.903 19.903 0 0 1-52 0c-11.046 0-20-8.954-20-20h52C-8.954-20 0-11.046 0 0z",
  style: {
    fill: "none",
    stroke: "var(--illustration-secondary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(896 332)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0c0 11.046-8.954 20-20 20s-20-8.954-20-20c0-1.515.183-2.984.502-4.402A19.905 19.905 0 0 1-52 0c-11.046 0-20-8.954-20-20h52C-8.954-20 0-11.046 0 0",
  style: {
    fill: "var(--illustration-secondary)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(1704 316)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0c0 11.046-8.954 20-20 20s-20-8.954-20-20c0-1.515.183-2.984.502-4.402A19.905 19.905 0 0 1-52 0c-11.046 0-20-8.954-20-20h52C-8.954-20 0-11.046 0 0z",
  style: {
    fill: "none",
    stroke: "var(--illustration-secondary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1704 316)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0c-12.923 0-24.048-7.665-29.1-18.692C-32.762-14.594-38.072-12-44-12c-8.199 0-15.237-4.939-18.325-12h93.317C27.439-10.198 14.911 0 0 0",
  style: {
    fill: "var(--illustration-secondary)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(616 472)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0c-12.923 0-24.048-7.665-29.1-18.692C-32.762-14.594-38.072-12-44-12c-8.199 0-15.237-4.939-18.325-12h93.317C27.439-10.198 14.911 0 0 0Z",
  style: {
    fill: "none",
    stroke: "var(--illustration-secondary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(616 472)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0c-12.923 0-24.048-7.665-29.1-18.692C-32.763-14.594-38.072-12-44-12c-8.199 0-15.237-4.939-18.324-12h93.316C27.439-10.198 14.911 0 0 0",
  style: {
    fill: "var(--illustration-secondary)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(2321 384)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0c-12.923 0-24.048-7.665-29.1-18.692C-32.763-14.594-38.072-12-44-12c-8.199 0-15.237-4.939-18.324-12h93.316C27.439-10.198 14.911 0 0 0Z",
  style: {
    fill: "none",
    stroke: "var(--illustration-secondary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(2321 384)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 6-6 8 8 8-8 6 6",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(718 278)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 6-6 8 8 8-8 6 6",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(566 286)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 6-6 8 8 8-8 6 6",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(50 345.272)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0c0 7.453 5.103 13.697 12 15.476A15.99 15.99 0 0 1 8 16C-.836 16-8 8.837-8 0S-.836-16 8-16c1.384 0 2.719.194 4 .524C5.103-13.697 0-7.453 0 0",
  style: {
    fill: "var(--illustration-secondary)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(768 184)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0c0 7.453 5.103 13.697 12 15.476A15.99 15.99 0 0 1 8 16C-.836 16-8 8.837-8 0S-.836-16 8-16c1.384 0 2.719.194 4 .524C5.103-13.697 0-7.453 0 0Z",
  style: {
    fill: "none",
    stroke: "var(--illustration-secondary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(768 184)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-16",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(776 176)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0c0-8.837-7.164-16-16-16S-32-8.837-32 0s7.164 16 16 16S0 8.837 0 0Z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(792 184)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0c0 7.453 5.103 13.697 12 15.476A15.99 15.99 0 0 1 8 16C-.836 16-8 8.837-8 0S-.836-16 8-16c1.384 0 2.719.194 4 .524C5.103-13.697 0-7.453 0 0",
  style: {
    fill: "var(--illustration-secondary)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(128 24)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0c0 7.453 5.103 13.697 12 15.476A15.99 15.99 0 0 1 8 16C-.836 16-8 8.837-8 0S-.836-16 8-16c1.384 0 2.719.194 4 .524C5.103-13.697 0-7.453 0 0Z",
  style: {
    fill: "none",
    stroke: "var(--illustration-secondary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(128 24)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-16",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(136 16)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0c0-8.837-7.164-16-16-16S-32-8.837-32 0s7.164 16 16 16S0 8.837 0 0Z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(152 24)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0a3 3 0 1 0-6 0 3 3 0 0 0 6 0",
  style: {
    fill: "var(--illustration-background)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(347 224)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0a3 3 0 1 0-6 0 3 3 0 0 0 6 0z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(347 224)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0a3 3 0 1 0-6 0 3 3 0 0 0 6 0",
  style: {
    fill: "var(--illustration-background)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(699 240)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0a3 3 0 1 0-6 0 3 3 0 0 0 6 0z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(699 240)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0a3 3 0 1 0-6 0 3 3 0 0 0 6 0",
  style: {
    fill: "var(--illustration-background)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(683 16)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0a3 3 0 1 0-6 0 3 3 0 0 0 6 0z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(683 16)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0a3 3 0 1 0-6 0 3 3 0 0 0 6 0",
  style: {
    fill: "var(--illustration-background)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(163 192)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0a3 3 0 1 0-6 0 3 3 0 0 0 6 0z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(163 192)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h126.875a24 24 0 0 0 15.945-6.062l58.36-51.876A24 24 0 0 1 217.125-64H1388",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1112 200)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-694.963",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1988 160)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0c-34.894 0-65.138 27.507-80 56-14.862-28.493-45.106-48-80-48",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1912 160)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0c-34.894 0-65.138 19.507-80 48-14.862-28.493-45.106-48-80-48",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1752 168)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-80",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1512 216)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-43.411",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1520 203.411)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-34.277",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1528 194.277)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-27.208",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1536 187.208)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-21.616",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1544 181.616)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-17.192",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1552 177.192)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-13.753",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1560 173.753)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-11.179",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1568 171.179)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-9.393",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1576 169.393)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-8.346",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1584 168.346)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-43.411",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1664 203.411)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-34.277",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1656 194.277)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-27.208",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1648 187.208)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-21.616",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1640 181.616)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-17.192",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1632 177.192)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-13.753",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1624 173.753)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-11.179",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1616 171.179)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-9.393",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1608 169.393)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-8.346",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1600 168.346)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-43.411",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1824 203.411)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-34.277",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1816 194.277)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-27.208",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1808 187.208)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-21.616",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1800 181.616)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-17.192",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1792 177.192)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-13.753",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1784 173.753)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-11.179",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1776 171.179)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-9.393",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1768 169.393)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-8.346",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1760 168.346)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-42.892",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1840 202.892)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-32",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1848 192)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-24.472",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1856 184.472)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-17.687",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1864 177.688)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-12.146",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1872 172.147)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-7.718",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1880 167.718)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-4.324",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1888 164.324)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-42.892",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1504 202.892)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-32",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1496 192)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-24.472",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1488 184.472)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-17.687",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1480 177.688)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-12.146",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1472 172.147)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-7.718",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1464 167.718)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-4.324",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1456 164.324)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-43.411",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1680 203.411)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-34.277",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1688 194.277)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-27.208",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1696 187.208)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-21.616",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1704 181.616)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-17.192",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1712 177.192)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-13.753",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1720 173.753)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-11.179",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1728 171.179)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-9.393",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1736 169.393)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-8.346",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1744 168.346)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-80",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1672 216)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-80",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1832 216)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-8",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1592 168)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-8",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1752 168)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0a3 3 0 1 0-6 0 3 3 0 0 0 6 0",
  style: {
    fill: "var(--illustration-background)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(1675 160)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0a3 3 0 1 0-6 0 3 3 0 0 0 6 0z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1675 160)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0a3 3 0 1 0-6 0 3 3 0 0 0 6 0",
  style: {
    fill: "var(--illustration-background)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(1515 160)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0a3 3 0 1 0-6 0 3 3 0 0 0 6 0z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1515 160)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0a3 3 0 1 0-6 0 3 3 0 0 0 6 0",
  style: {
    fill: "var(--illustration-background)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(1835 160)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0a3 3 0 1 0-6 0 3 3 0 0 0 6 0z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1835 160)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 62.931 41.954A36.004 36.004 0 0 0 82.9 48h240.472a35.996 35.996 0 0 1 22.489 7.889l20.278 16.222A35.996 35.996 0 0 0 388.628 80H554",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1952 136)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 69.731 62.759A36.004 36.004 0 0 0 93.814 72H308",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(2200 184)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h98.088a36 36 0 0 0 25.456-10.544l26.912-26.912A36 36 0 0 1 175.912-48h49.219",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1119 136)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0s-5.373-4-12-4-12 4-12 4-5.373-4-12-4-12 4-12 4-5.373-4-12-4-12 4-12 4",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1512 36)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0s-5.373-4-12-4-12 4-12 4-5.373-4-12-4-12 4-12 4-5.373-4-12-4-12 4-12 4",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1600 84)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0s-5.373-4-12-4-12 4-12 4-5.373-4-12-4-12 4-12 4-5.373-4-12-4-12 4-12 4",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1946 84)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0s-5.373-4-12-4-12 4-12 4-5.373-4-12-4-12 4-12 4-5.373-4-12-4-12 4-12 4",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(2184 48)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0s-5.373-4-12-4-12 4-12 4-5.373-4-12-4-12 4-12 4-5.373-4-12-4-12 4-12 4",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(2432 80)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0a11.953 11.953 0 0 0 7.655 2.759c5.534 0 10.193-3.746 11.58-8.841",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1132.345 29.241)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0a11.942 11.942 0 0 0 6.938 2.208c5.534 0 10.193-3.746 11.58-8.841",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1149.062 21.792)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0a11.94 11.94 0 0 0 5.72 1.448c6.627 0 12-5.373 12-12 0-1.402-.241-2.749-.683-4",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1166.28 14.552)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0a3 3 0 1 0-6 0 3 3 0 0 0 6 0",
  style: {
    fill: "var(--illustration-background)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(915)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0a3 3 0 1 0-6 0 3 3 0 0 0 6 0z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(915)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-8l4 16z",
  style: {
    fill: "var(--illustration-background)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(2392 260)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-8l4 16z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(2392 260)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-4",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(2388 260)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-8l4 16z",
  style: {
    fill: "var(--illustration-background)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(2440 260)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-8l4 16z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(2440 260)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-4",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(2436 260)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h16L8 32Z",
  style: {
    fill: "var(--illustration-background)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(2432 144)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h4l-8 32Z",
  style: {
    fill: "var(--illustration-secondary)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(2444 144)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h4l-8 32Z",
  style: {
    fill: "none",
    stroke: "var(--illustration-secondary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(2444 144)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h16L8 32Z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(2432 144)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-16",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(2440 152)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h16L8 32Z",
  style: {
    fill: "var(--illustration-background)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(2392 144)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h4l-8 32Z",
  style: {
    fill: "var(--illustration-secondary)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(2404 144)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h4l-8 32Z",
  style: {
    fill: "none",
    stroke: "var(--illustration-secondary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(2404 144)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h16L8 32Z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(2392 144)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-16",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(2400 152)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h16L8 32Z",
  style: {
    fill: "var(--illustration-background)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(2352 144)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h4l-8 32Z",
  style: {
    fill: "var(--illustration-secondary)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(2364 144)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h4l-8 32Z",
  style: {
    fill: "none",
    stroke: "var(--illustration-secondary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(2364 144)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h16L8 32Z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(2352 144)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-16",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(2360 152)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 24-64h-72Z",
  style: {
    fill: "var(--illustration-background)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(1752 112)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0-32-64h-16Z",
  style: {
    fill: "var(--illustration-secondary)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(1752 112)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0-32-64h-16Z",
  style: {
    fill: "none",
    stroke: "var(--illustration-secondary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1752 112)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-72M0 0l24-64h-72Z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1752 112)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0s-5.373-4-12-4-12 4-12 4-5.373-4-12-4-12 4-12 4-5.373-4-12-4-12 4-12 4-5.373-4-12-4-12 4-12 4-5.373-4-12-4-12 4-12 4-5.373-4-12-4-12 4-12 4",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1824 36)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0s5.373-4 12-4 12 4 12 4 5.373-4 12-4c1.505 0 2.938.212 4.266.531L44 4h-60l7.619-7.619C-3.522-2.621 0 0 0 0",
  style: {
    fill: "var(--illustration-background)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(1728 36)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0s5.373-4 12-4 12 4 12 4 5.373-4 12-4c1.505 0 2.938.212 4.266.531L44 4h-60l7.619-7.619C-3.522-2.621 0 0 0 0Z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1728 36)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-68",
  style: {
    fill: "var(--illustration-background)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1776 40)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0c34.894 0 65.138 27.507 80 56 14.862-28.493 45.106-48 80-48",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1432 160)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0a3 3 0 1 0-6 0 3 3 0 0 0 6 0",
  style: {
    fill: "var(--illustration-background)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(1323 48)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0a3 3 0 1 0-6 0 3 3 0 0 0 6 0z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1323 48)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0a3 3 0 1 0-6 0 3 3 0 0 0 6 0",
  style: {
    fill: "var(--illustration-background)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(1296 160)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0a3 3 0 1 0-6 0 3 3 0 0 0 6 0z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1296 160)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0a3 3 0 1 0-6 0 3 3 0 0 0 6 0",
  style: {
    fill: "var(--illustration-background)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(907 136)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0a3 3 0 1 0-6 0 3 3 0 0 0 6 0z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(907 136)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0a3 3 0 1 0-6 0 3 3 0 0 0 6 0",
  style: {
    fill: "var(--illustration-background)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(1347.13 88)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0a3 3 0 1 0-6 0 3 3 0 0 0 6 0z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1347.13 88)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0a3 3 0 1 0-6 0 3 3 0 0 0 6 0",
  style: {
    fill: "var(--illustration-background)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(1128 88)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0a3 3 0 1 0-6 0 3 3 0 0 0 6 0z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1128 88)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0c0-8.837 7.163-16 16-16S32-8.837 32 0s-7.163 16-16 16S0 8.837 0 0",
  style: {
    fill: "var(--illustration-background)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(2240 160)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0c0 7.453-5.103 13.697-12 15.476 1.28.33 2.616.524 4 .524C.837 16 8 8.837 8 0S.837-16-8-16c-1.384 0-2.72.194-4 .524C-5.103-13.697 0-7.453 0 0",
  style: {
    fill: "var(--illustration-secondary)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(2264 160)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0c0 7.453-5.103 13.697-12 15.476 1.28.33 2.616.524 4 .524C.837 16 8 8.837 8 0S.837-16-8-16c-1.384 0-2.72.194-4 .524C-5.103-13.697 0-7.453 0 0Z",
  style: {
    fill: "none",
    stroke: "var(--illustration-secondary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(2264 160)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-16",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(2256 152)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0c0-8.837 7.163-16 16-16S32-8.837 32 0s-7.163 16-16 16S0 8.837 0 0Z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(2240 160)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h72",
  style: {
    fill: "var(--illustration-background)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1028 328)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v10h-1L-3 0l-36-24h24z",
  style: {
    fill: "var(--illustration-secondary)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(1063 352)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v10h-1L-3 0l-36-24h24z",
  style: {
    fill: "none",
    stroke: "var(--illustration-secondary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1063 352)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v16",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1064 367)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0-2 9.706h-4L-8 0l-36-24.294h80z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1068 352.294)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0a5 5 0 1 0-10.001.001A5 5 0 0 0 0 0",
  style: {
    fill: "var(--illustration-background)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(1069 363)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0c0 2.235 1.477 4.105 3.5 4.746C3.024 4.896 2.526 5 2 5A5 5 0 0 1 2-5c.526 0 1.024.104 1.5.254C1.477-4.105 0-2.235 0 0",
  style: {
    fill: "var(--illustration-secondary)",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(1062 363)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0c0 2.235 1.477 4.105 3.5 4.746C3.024 4.896 2.526 5 2 5A5 5 0 0 1 2-5c.526 0 1.024.104 1.5.254C1.477-4.105 0-2.235 0 0Z",
  style: {
    fill: "none",
    stroke: "var(--illustration-secondary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1062 363)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0a5 5 0 1 0-10.001.001A5 5 0 0 0 0 0z",
  style: {
    fill: "none",
    stroke: "var(--illustration-primary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(1069 363)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0c0-22.091-17.908-40-40-40S-80-22.091-80 0s17.908 40 40 40S0 22.091 0 0Z",
  style: {
    fill: "none",
    stroke: "var(--illustration-secondary)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(2000 360)"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBridge);
export default ForwardRef;